export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-refresh-e838cae9b414d60dce78ccab4b15fb1a.svg";